Apt.fn.make('profile', {
	/**
	 * Initialize module
	 */
	init() {
		const priv = this.$private;
		const context = $.context();

		priv.id = context.id;
		priv.type = context.type;

		priv.initScreen();
		priv.initAnalytics();
		priv.initListings();
		priv.initMembers();
		priv.initContact();
		priv.initTruncate();

		LS.util.idle(() => {
			priv.initShare(priv, 'profile', {
				target: 'profile',
				label: 'profile',
				id: priv.id
			});

			priv.initMessage();
			priv.initReport();

			Apt.properties.prefetch();
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		const priv = this.$private;

		if (! priv.id) {
			return;
		}

		LS.util.reset('profile', priv, [
			'map',
			'listings',
			'members',
			'call',
			'message',
			'report',
			'share'
		]);

		priv.truncate.forEach(el => {
			el.$destroy();
		});
	}
}, {
	/**
	 * Register responsive element positioning
	 */
	initScreen() {
		$.screen.map([
			{
				max: 3,
				callback: () => {
					$$('profileMeta').appendTo('$profileRight');
				}
			},
			{
				min: 4,
				init: false,
				callback: () => {
					$$('profileMeta').appendTo('$profileLeft');
				}
			}
		], {
			namespace: 'profile'
		});
	},

	/**
	 * Initialize profile reporting
	 */
	initReport() {
		const scope = this;

		scope.report = Apt.fn.report().init({
			target: 'profiles',
			id: scope.id
		});
	},

	/**
	 * Initialize message form
	 */
	initMessage() {
		if (! $$('message').length) {
			return;
		}

		const scope = this;
		const placeholders = {
			agent: 'I need help buying or selling land',
			lender: 'I\'m interested in land financing',
			service: 'I\'m interested in your services'
		};

		scope.message = Apt.fn.message()
			.init({
				target: 'profile',
				id: scope.id,
				placeholder: placeholders[scope.type],
				required: true
			});

		$$('messageModal').on('click', () => {
				LS.util.view('profile', 'rules', template => {
					LS.modal.open({
						model: {
							title: 'Message rules',
							content: template
						},
						width: 520
					});
				});
			}, {
				namespace: 'profile'
			});
	},

	/**
	 * Initialize profile event tracking
	 */
	initAnalytics() {
		const scope = this;
		const id = scope.id;

		LS.analytics.track({
			action: 'view',
			target: 'profile',
			id: id,
			category: 'entry'
		});

		scope.call = Apt.fn.call()
			.init({
				target: 'profile',
				id: id
			});

		$$('profileWebsite').on('click', () => {
			LS.analytics.track({
				action: 'click',
				target: 'profile',
				id: id,
				category: 'link',
				segment: 'website'
			});
		}, {
			namespace: 'profile'
		});

		$$('profileSocial').on('click', (e, el) => {
			LS.analytics.track({
				action: 'click',
				target: 'profile',
				id: id,
				category: 'link',
				segment: 'social',
				attributes: {
					type: el.dataset.type
				}
			});
		}, {
			namespace: 'profile'
		});
	},

	/**
	 * Initialize mobile contact
	 */
	initContact() {
		$$('profileContact').on('click', () => {
			LS.util.setScroll('$profileForm');
		}, {
			namespace: 'profile'
		});
	},

	/**
	 * Lazy initialize sharing
	 *
	 * @param {Object} context
	 * @param {String} namespace
	 * @param {Object} options
	 */
	initShare(context, namespace, options) {
		$$('profileShare').on('click', () => {
			if (context.share) {
				context.share.show();

				return;
			}

			LS.util.load('share', () => {
				context.share = Apt.fn.share()
					.init(options);

				context.share.show();
			});
		}, {
			cancel: true,
			namespace: namespace
		});
	},

	/**
	 * Initialize truncation
	 */
	initTruncate() {
		this.truncate = $$('truncate').map(el => Apt.fn.truncate()
			.init(el)
		);
	}
});